















import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { Vessel } from "@/types/vessel";
import DfiSelectMultiple from "../DfiForm/DfiSelectMultiple.vue";

@Component({
  components: {
    DfiSelectMultiple,
  },
})
export default class VesselSelect extends Vue {
  @Model("update:modelValue") vessels!: Vessel[];
  @Prop({ required: true }) vesselsList!: Vessel[];
  @Prop({ default: false }) opened!: boolean;

  valueFormatter(selected: number) {
    if (selected === 0) return "";

    return `${selected} vessel${selected > 1 ? "s" : ""} selected`
  }

  onVesselChange(vessels: Vessel[]) {
    this.$emit("update:modelValue", vessels);
  }
}
